module.exports = __webpack_public_path__ + "media/images/icon__live@3x-a8ab4b1d559082a3ce773952ccbd198b.png";